import { useCallback, useContext } from 'react'

import { GenericError } from '@auth0/auth0-react'
import { useGlobalModalContext } from '@editor/contexts/GlobalModal'
import { UserContext } from '@editor/contexts/Users'
import { getBlueprints } from '@editor/services/Blueprint'
import { COMMON_MESSAGE } from '@editor/services/ErrorHandler'
import { useLocation, useParams } from 'react-router'

/**
 * Initializes and manages blueprint-related state and actions.
 */
const useBlueprint = () => {
  // Router
  const location = useLocation()
  const { project_id } = useParams<{ project_id: string }>()
  const queries = new URLSearchParams(location.search)
  const inspection_area_id = queries.get('area')

  // Hooks
  const { showErrorModal } = useGlobalModalContext()
  const { getAccessToken } = useContext(UserContext)

  /**
   * Load blueprints for the current project and inspection area.
   */
  const fetchBlueprints = useCallback(async () => {
    if (!project_id || !inspection_area_id) return null

    const accessToken = await getAccessToken()
    if (!accessToken) return null

    // Load blueprints
    return getBlueprints(accessToken, project_id, inspection_area_id)
      .then((res) => res.results)
      .catch((err) => {
        showErrorModal(err instanceof GenericError ? err.message : COMMON_MESSAGE)
        return null
      })
  }, [project_id, inspection_area_id, getAccessToken, showErrorModal])

  return {
    fetchBlueprints,
  }
}

export default useBlueprint
